import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import ClinicianPayrollDetails from "./ClinicianPayrollDetails";
import HRPayrollDetails from "./HRPayrollDetails";

export default function PayrollSlideOver({
  isOpen,
  appointment,
  payrolldata,
  payrollId,
  onClose,
  selectedPeriod,
  selectedPeriodDates,
  submitBy,
  payBy,
  isHr,
  onUpdateSuccess,
  refetchInvoices,
}) {
  const handleUpdateSuccess = () => {
    if (onUpdateSuccess) {
      onUpdateSuccess(); // Call the parent-provided callback
      console.log("handle update success called");
    }
  };

  console.log("RECEVIED THIS APPT IN PAYROLLSLIDEOVER", appointment);

  if (!appointment || !appointment._id) {
    console.error("Appointment data is missing or invalid:", appointment);
  } else {
    console.log("Valid appointment ID:", appointment._id);
  }

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16 md:pl-30">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full">
                <Dialog.Panel className="pointer-events-auto w-screen max-w-4xl">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                          Payroll Details
                        </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="relative rounded-sm bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={onClose}>
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                      {isHr ? (
                        <HRPayrollDetails
                          payrollId={appointment.payrollId}
                          appointment={appointment.appointment}
                          selectedPeriod={selectedPeriod}
                          selectedPeriodDates={selectedPeriodDates}
                          submitBy={submitBy}
                          payBy={payBy}
                          onUpdateSuccess={() => {
                            if (onUpdateSuccess) {
                              onUpdateSuccess(); // Propagate callback to parent
                            }
                            onClose(); // Close the slide-over
                          }}
                        />
                      ) : (
                        <ClinicianPayrollDetails
                          payroll={payrolldata}
                          payrollId={appointment.payrollId}
                          appointment={appointment.appointment}
                          invoice={appointment.invoice}
                          selectedPeriod={selectedPeriod}
                          selectedPeriodDates={selectedPeriodDates}
                          refetchInvoices={refetchInvoices}
                          submitBy={submitBy}
                          payBy={payBy}
                          onRefresh={onClose}
                        />
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
